import client from "./client";

export interface AdminUserRow {
  id: string;
  email: string;
  role: string;
  is_active: boolean;
  is_platform_admin: boolean;
  mfa_enabled: boolean;
  last_login: string | null;
  created_at: string | null;
  org: {
    id: string;
    name: string;
    slug: string;
    plan: string;
  };
}

export interface AdminOrgRow {
  id: string;
  name: string;
  slug: string;
  domain: string | null;
  plan: string;
  subscription_status: string | null;
  current_period_end: string | null;
  created_at: string | null;
}

export interface ImpersonateResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  target: { id: string; email: string; role: string; org_id: string };
}

export async function searchUsers(q: string, limit = 25): Promise<AdminUserRow[]> {
  const { data } = await client.get("/admin/users", { params: { q, limit } });
  return data.items ?? [];
}

export async function searchOrgs(q: string, limit = 25): Promise<AdminOrgRow[]> {
  const { data } = await client.get("/admin/orgs", { params: { q, limit } });
  return data.items ?? [];
}

export async function impersonate(
  user_id: string,
  reason: string,
  ttl_minutes = 15,
): Promise<ImpersonateResponse> {
  const { data } = await client.post("/admin/impersonate", {
    user_id,
    reason,
    ttl_minutes,
  });
  return data;
}

export async function forceLogout(user_id: string, reason: string): Promise<void> {
  await client.post("/admin/force-logout", { user_id, reason });
}
